module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6891af6b9c97590c34cbbc234d66d24c.png";